module.exports = __webpack_public_path__ + "img/SISGEOMOVSALA2.24ef0959.svg";